import { HttpClient } from "@/shared/http";

import type {
  CreateUserGroupRequest,
  UpdateUserGroupRequest,
  UserGroupRecord,
} from "./UserGroupRecord";

export class UserGroupService {
  #httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.#httpClient = httpClient;
  }

  public async getAll(
    options?: Partial<{ abortSignal: AbortSignal }>,
  ): Promise<UserGroupRecord[]> {
    const url = this.#httpClient.constructUrl("v1/user_groups");
    const response = await this.#httpClient.get(url, {
      signal: options?.abortSignal,
    });
    return response.json<UserGroupRecord[]>();
  }

  public async create(
    request: CreateUserGroupRequest,
  ): Promise<UserGroupRecord> {
    const url = this.#httpClient.constructUrl("v1/user_groups");
    const response = await this.#httpClient.post(url, {
      body: JSON.stringify(request),
    });
    return response.json<UserGroupRecord>();
  }

  public async update(
    userGroupId: string,
    request: UpdateUserGroupRequest,
  ): Promise<UserGroupRecord> {
    const url = this.#httpClient.constructUrl(`v1/user_groups/${userGroupId}`);
    const response = await this.#httpClient.put(url, {
      body: JSON.stringify(request),
    });
    return response.json<UserGroupRecord>();
  }

  public async remove(userGroupId: string): Promise<void> {
    const url = this.#httpClient.constructUrl(`v1/user_groups/${userGroupId}`);
    const response = await this.#httpClient.delete(url);
    return response.throwIfError();
  }
}
